import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DownloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

const client = "a7";
const table_name = "a7_fia_download_center";

export default function A7FIADownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={
          <DownloadCenterTable client={client} table_name={table_name} />
        }
      />
    </Routes>
  );
}
